// components/Modals/ConfirmChangeSubscription.jsx
import React from "react";
import BaseModal from "./BaseModal";
import { InfoIcon } from "lucide-react";

const ConfirmChangeSubscription = ({ open, onClose, onConfirm }) => {
  return (
    <BaseModal open={open} onClose={onClose}>
      <div className="p-6 text-center space-y-4">
        <div className="mx-auto h-14 w-14 rounded-full bg-[#FFEFEB] flex items-center justify-center">
          <InfoIcon className="text-[#FF6943]" size={26} />
        </div>
        <p className="text-sm text-gray-500">
          note: The Subscription changes will affect future orders only
        </p>

        <div className="flex gap-3 mt-6">
          <button
            onClick={onClose}
            className="flex-1 py-2 rounded-full border border-[#FF6943] text-[#FF6943]"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            className="flex-1 py-2 rounded-full bg-[#FF6943] text-white"
          >
            Continue
          </button>
        </div>
      </div>
    </BaseModal>
  );
};

export default ConfirmChangeSubscription;
